
import FundSearch from "../components/FundSearch"
import FundEsgCompareTable from "../components/FundESGCompareTable"
import FundEsgRatingMultiLineChart from "../components/FundESGRatingMultiLineChart"
import { initReportOptions } from "./report_trans"
export default {
    components: {FundSearch,FundEsgCompareTable, FundEsgRatingMultiLineChart},
    data() {
        return {
            compare_content: "",
            report_period: "",
            product_ids: [],
            report_options: [
            ],
            select_event: false
        }
    },
    methods: {
        
        reportFilter(inputValue, path) {
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },
        compareFilter(inputValue, path) {
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },
        reportOnChange(value, selectedOptions){
            this.report_period = ""
            value.forEach(element => {
                this.report_period += element
            })
            if(!value[1]&&value[0]) {
                this.report_period += 'Q14'
            }
        },
        compareOnChange(value, selectedOptions){
            this.compare_content = ""
            value.forEach(element => {
                this.compare_content += element
            })
        },
    },
    created() {
        initReportOptions(this.report_options)
    },
    computed: {
        compare_options() {
            return [
                {label: this.$t('topNavBar.fund_esg_indicators'), value: 'fund_esg_indicators'},
                {label: this.$t('topNavBar.fund_esg_rating'), value: 'fund_esg_rating'},
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/fund_esg/js/fund_esg_compare.js